import { IPromiseBasedObservable } from 'mobx-utils';
import { useCallback, useEffect, useState } from 'react';

const fakePromise = createPendingPromise();

export default function usePromise<T>(
  promiseFactory: () => IPromiseBasedObservable<T>,
  dependencies: any[] = [],
): [Promised<T>, () => void] {
  const [promise, setPromise] = useState(fakePromise);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const reloadFiles = useCallback(
    () => setRefreshCounter((v) => v + 1),
    [setRefreshCounter],
  );

  useEffect(() => {
    setPromise(promiseFactory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCounter, ...dependencies]);

  return [promise as any, reloadFiles];
}

function createPendingPromise(): IPromiseBasedObservable<any> {
  return Object.assign(new Promise(() => {}), {
    isPromiseBasedObservable: true,
    value: undefined,
    state: 'pending',
    case(handlers?: { pending: () => void }) {
      handlers?.pending();
    },
  }) as any;
}

export type Promised<T> = {
  value: null | T;
} & IPromiseBasedObservable<T>;
